import React, { useState } from 'react';

import { useHistory } from 'react-router';

import * as ROUTES from '@constants/routes';
import ShowAccountData from '@components/ShowAccountData';
import NotAddedAccount from '@components/NotAddedAccount';
import ConfirmModal from '@components/Modal/ConfirmModal';
import { useBankAccount } from '@hooks';
import { isAllowed } from '@helpers/auth';

const BankAccount = ({ htmlIdButtonNotAddedAccount }) => {
  const history = useHistory();
  const [confirmModal, setConfirmModal] = useState(false);
  const { bankAccount, deleteBankAccount } = useBankAccount();
  const showModifyBankAccount = isAllowed('WITHDRAW_MODIFY_BANK_ACCOUNT');

  const handleDelete = () => {
    setConfirmModal(true);
  };

  const handleEdit = () => {
    history.push(ROUTES.FUNDS_OUT_EDIT_BANK_ACCOUNT);
  };

  const handleAddAccount = () => {
    history.push(ROUTES.FUNDS_OUT_ADD_BANK_ACCOUNT);
  };

  const handleDeleteCancel = () => {
    setConfirmModal(false);
  };

  const handleDeleteConfirm = () => {
    deleteBankAccount();
    setConfirmModal(false);
  };

  return (
    <>
      {bankAccount ? (
        <ShowAccountData
          data-testid="bank-account-show-account-data"
          bankAccount={bankAccount}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          showModifyBankAccount={showModifyBankAccount}
        />
      ) : (
        <NotAddedAccount
          htmlIdButton={htmlIdButtonNotAddedAccount}
          data-testid="bank-account-not-added-account"
          handleAddAccount={handleAddAccount}
        />
      )}
      {confirmModal && showModifyBankAccount && (
        <ConfirmModal
          data-testid="bank-account-confirm-modal"
          title="¿Quieres eliminar la cuenta?"
          open={confirmModal}
          textCancel="Cancelar"
          textConfirm="Eliminar"
          handleCancel={handleDeleteCancel}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </>
  );
};

export default BankAccount;
